import {apiClient} from '@common/http/query-client';

export type ShareAccessPermission = 'view' | 'download' | 'edit';

export type ShareAccessRequestRecord = {
  id: number;
  token: string;
  status: 'pending' | 'approved' | 'denied';
  requester_name: string | null;
  requester_email: string;
  message: string | null;
  permission_key: ShareAccessPermission | null;
  permissions?: {
    view?: boolean;
    download?: boolean;
    edit?: boolean;
  } | null;
  access_expires_at: string | null;
  created_at: string;
  decided_at: string | null;
  activity?: {
    action: string;
    permission?: string | null;
    at?: string;
  }[];
  entry_name?: string;
  entry_type?: string;
  link_hash?: string;
};

export type ShareLinkPreview = {
  hash: string;
  name: string;
  type: string;
};

export async function requestShareAccess(
  hash: string,
  body: {name?: string; email: string; message?: string},
) {
  const {data} = await apiClient.post<{
    status: string;
    already_requested?: boolean;
    request_status?: string;
    message: string;
  }>(`shareable-link-page/${hash}/request-access`, body);
  return data;
}

export async function fetchShareAccessStatus(hash: string) {
  const {data} = await apiClient.get<{data: ShareAccessRequestRecord | null}>(
    `shareable-link-page/${hash}/request-access`,
  );
  return data.data;
}

export async function fetchShareAccessRequest(token: string) {
  const {data} = await apiClient.get<{data: ShareAccessRequestRecord}>(
    `share-access/${token}`,
  );
  return data.data;
}

export async function decideShareAccessByToken(
  token: string,
  body: {
    action: 'approve' | 'deny';
    permission?: ShareAccessPermission;
    access_expires_at?: string | null;
  },
) {
  const {data} = await apiClient.post<{data: ShareAccessRequestRecord}>(
    `share-access/${token}/decide`,
    body,
  );
  return data.data;
}

export async function listShareAccessRequests(entryId: number) {
  const {data} = await apiClient.get<{data: ShareAccessRequestRecord[]}>(
    `file-entries/${entryId}/share-access-requests`,
  );
  return data.data;
}

export async function decideShareAccessById(
  id: number,
  body: {
    action: 'approve' | 'deny';
    permission?: ShareAccessPermission;
    access_expires_at?: string | null;
  },
) {
  const {data} = await apiClient.post<{data: ShareAccessRequestRecord}>(
    `share-access-requests/${id}/decide`,
    body,
  );
  return data.data;
}

export async function resendShareAccessGrant(id: number) {
  const {data} = await apiClient.post<{data: ShareAccessRequestRecord}>(
    `share-access-requests/${id}/resend`,
  );
  return data.data;
}
